//TODO: needs to be extended when we have configured Akamai Image Manager
export default function BuienradarImageLoader({ src, width }) {
  return `${src}?width=${width}`;
}
